import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import Link from '@/components/utils/Link';
import { URL } from '@/constants';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';
import { i18n } from '../DeltaAdvPC/i18n';
import { useRouter } from 'next/router';

export default function AARS({ theme = 'black', local = 'us' }) {
    const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN } = URL;
    const { locale = 'us' } = useRouter();
    const {
        title,
        desc,
        item1_subtitle,
        item1_title,
        item1_desc,
        item2_subtitle,
        item2_title,
        item2_desc,
        item3_subtitle,
        item3_title,
        item3_desc,
        list1_subtitle,
        list1_title,
        list1_desc,
        list2_title,
        list2_desc,
        list3_title,
        list3_desc,
        tip,
    } = i18n[locale] || i18n['en'];

    const getAppDataLayer = (type: string) => ({
        event: 'uaEvent',
        event_name: 'ecoflow_app',
        button_name: type,
    });

    const getRiver2Optimization = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(local)) {
            return (
                <div className="img-big">
                    <div className="card">
                        <p className="sub-title">{list1_subtitle}</p>
                        <p className="title">{list1_title}</p>
                        <p className="desc">{list1_desc}</p>
                        <NextImage src={require('@publicLocal/app-point/h5/rs_adv_4.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                    </div>
                    <div className="card">
                        <p className="sub-title"></p>
                        <p className="title">{list2_title}</p>
                        <p className="desc">{list2_desc}</p>
                        <NextImage src={require('@publicLocal/app-point/h5/rs_adv_5.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                    </div>
                    <div className="card">
                        <p className="sub-title"></p>
                        <p className="title">{list3_title}</p>
                        <p className="desc">{list3_desc}</p>
                        <NextImage src={require('@publicLocal/app-point/h5/rs_adv_3.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                    </div>
                </div>
            );
        }
        return (
            <div className="img-big">
                <div className="card">
                    <p className="sub-title">{list1_subtitle}</p>
                    <p className="title">{list1_title}</p>
                    <p className="desc">{list1_desc}</p>
                    <NextImage
                        src={
                            locale === 'ph'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1751082738068/2.jpg'
                                : require('@publicLocal/app-point/h5/rs_adv_3.jpg')
                        }
                        alt={'EcoFlow app'}
                        aria-label={'EcoFlow app'}
                    />
                </div>
                <div className="card">
                    <p className="sub-title"></p>
                    <p className="title">{list2_title}</p>
                    <p className="desc">{list2_desc}</p>
                    <NextImage
                        src={
                            locale === 'ph'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1751082738254/3.jpg'
                                : require('@publicLocal/app-point/h5/rs_adv_4.jpg')
                        }
                        alt={'EcoFlow app'}
                        aria-label={'EcoFlow app'}
                    />
                </div>
                <div className="card">
                    <p className="sub-title"></p>
                    <p className="title">{list3_title}</p>
                    <p className="desc">{list3_desc}</p>
                    <NextImage src={require('@publicLocal/app-point/h5/rs_adv_5.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                </div>
            </div>
        );
    };

    return (
        <div
            className={`${css.AARS} app-adv-rs`}
            style={{
                background: theme == 'black' ? '#000' : 'unset',
            }}
        >
            <div className={`content-wrapper ${theme}`}>
                <p className="title">{title}</p>
                <p className="desc">{desc}</p>
                <div className="img-wrapper">
                    <div className="panel">
                        <NextImage src={require('@publicLocal/app-point/h5/rs_adv_1.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        <div className="text-wrapper">
                            <p className="sub-title">{item1_subtitle}</p>
                            <p className="title">{item1_title}</p>
                            <p className="desc">{item1_desc}</p>
                        </div>
                    </div>
                    <div className="panel">
                        <NextImage
                            src={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751082737897/1.jpg'
                                    : require('@publicLocal/app-point/h5/rs_adv_2.jpg')
                            }
                            alt={'EcoFlow app'}
                            aria-label={'EcoFlow app'}
                        />
                        <div className="text-wrapper">
                            <p className="sub-title">{item2_subtitle}</p>
                            <p className="title">{item2_title}</p>
                            <p className="desc">{item2_desc}</p>
                        </div>
                    </div>
                    {getRiver2Optimization()}
                    <div className="panel">
                        <NextImage src={require('@publicLocal/app-point/h5/rs_adv_6.jpg')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        <div className="text-wrapper">
                            <p className="sub-title">{item3_subtitle}</p>
                            <p className="title">{item3_title}</p>
                            <p className="desc">{item3_desc}</p>
                        </div>
                    </div>
                </div>
                <div className="download-wrapper">
                    <p>{tip}</p>
                    <div className="icons">
                        <Link href={APP_IOS} dataLayer={getAppDataLayer('App Store')}>
                            <NextImage src={require('@publicLocal/app-point/app_store.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                        <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                            <NextImage src={require('@publicLocal/app-point/google_play.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
